import type { Invoice } from "@freightsimple/generated-dashboard-openapi-client/models/Invoice";

/**
 * The currency a set of invoices is denominated in, read off the invoices themselves.
 *
 * An invoice's currency is fixed when it is created and never rewritten, so it - not the company's
 * current currency - is what those amounts actually are. Labelling a total with the company
 * currency printed "USD" over a table of CAD rows.
 *
 * Returns undefined when the set holds more than one currency, because no single code describes
 * the total then. Callers drop the code rather than picking one and being wrong.
 */
export function invoicesSingleCurrency(
  invoices: Invoice[],
): string | undefined {
  const currencies = new Set(invoices.map((invoice) => invoice.currency));
  if (currencies.size !== 1) {
    return undefined;
  }
  return [...currencies][0]?.toUpperCase();
}
